export * from 'app/settings/cycle-2-et-3-tne-canope';
